<script lang="ts" setup>
import Button from '@satch-ui/components/button/Button.vue'
import { t } from '@storefront-satch/lib/translations'

type Props = {
  direction: 'backward' | 'forward'
  isLoading: boolean
}

const props = defineProps<Props>()
const emit = defineEmits<{
  (e: 'submit'): void
}>()

const labelMap = {
  backward: t('pagination.showPrevious'),
  forward: t('pagination.showMore'),
}
</script>

<template>
  <form
    class="flex items-center justify-center"
    @submit.prevent="emit('submit')"
  >
    <Button
      class="sm:w-2/5 lg:w-1/4"
      type="submit"
      :disabled="isLoading"
    >
      {{ labelMap[props.direction] }}
    </Button>
  </form>
</template>
